// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1hUkQ","inner":"Form_inner__ilDKw","range":"Form_range__2xJaM","name":"Form_name__luOnR","actions":"Form_actions__1vR__"};